import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=4fe021cf&scoped=true&"
import script from "./SalesView.vue?vue&type=script&lang=ts&"
export * from "./SalesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe021cf",
  null
  
)

export default component.exports